import React from 'react';
import { Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

// Wordmark: heavy, extra-wide Archivo. `light` for the black footer.
const Logo = ({ light = false, size = { base: '26px', md: '32px' }, ...rest }) => (
    <Text
        as={RouterLink}
        to='/'
        aria-label='Raano home'
        fontSize={size}
        fontWeight={900}
        lineHeight={1}
        letterSpacing='-0.02em'
        color={light ? 'raano.white' : 'raano.black'}
        sx={{ fontStretch: '125%' }}
        {...rest}
    >RAANO</Text>
);

export default Logo;
